import { useSelector } from "react-redux";

const useSidebarCollapsed = () => {
  const { menuDrawer } = useSelector((store) => store.app);
  const { isMobileAndTabletScreen } = useSelector((store) => store.appHeader);

  return Boolean(menuDrawer && !isMobileAndTabletScreen);
};

export default useSidebarCollapsed;
